import { Injectable } from '@angular/core';
import { ApiService, HttpResponse, HttpStatusEnum } from '@core/api';
import { TranslateService } from '@ngx-translate/core';
import { ToasterHelper } from '@shared/helpers';
import { MessageService } from 'primeng/api';
import {
    DashboardData,
    PrepareScheduleCourierPickupData,
    PrepareScheduleCourierPickupDTO,
    ScheduleCourierPickupData,
    ScheduleCourierPickupDTO,
    ScheduleCourierPickupPayload,
} from '../interfaces';
import { DashboardMapper } from './dashboard.mapper';

@Injectable()
export class DashboardApi {
    private readonly resourceUrl = 'dashboard';

    constructor(
        private apiService: ApiService,
        private messageService: MessageService,
        private translateService: TranslateService
    ) {}

    getDashboardData(): Promise<HttpResponse<DashboardData>> {
        return new Promise<HttpResponse<DashboardData>>(resolve => {
            this.apiService.get(`${this.resourceUrl}`).subscribe({
                next: (res: any) => {
                    resolve(DashboardMapper.mapGetDashboardData(res));
                },
                error: async () => {
                    resolve({ data: null, status: HttpStatusEnum.ERROR });
                },
            });
        });
    }

    getPrepareSchedulePickupData(): Promise<HttpResponse<PrepareScheduleCourierPickupData>> {
        return new Promise<HttpResponse<PrepareScheduleCourierPickupData>>(resolve => {
            this.apiService.get(`${this.resourceUrl}/prepare-courier-pickup`).subscribe({
                next: (res: PrepareScheduleCourierPickupDTO) => {
                    resolve(DashboardMapper.mapGetPrepareSchedulePickupData(res));
                },
                error: async () => {
                    resolve({ data: null, status: HttpStatusEnum.ERROR });
                },
            });
        });
    }

    scheduleCourierPickup(payload: ScheduleCourierPickupPayload): Promise<HttpResponse<ScheduleCourierPickupData>> {
        return new Promise<HttpResponse<ScheduleCourierPickupData>>(resolve => {
            this.apiService.post(`${this.resourceUrl}/schedule-courier-pickup`, payload).subscribe({
                next: (res: ScheduleCourierPickupDTO) => {
                    resolve(DashboardMapper.mapScheduleCourierPickupData(res));
                },
                error: async () => {
                    resolve({ data: null, status: HttpStatusEnum.ERROR });
                },
            });
        });
    }

    requestCustomQuote(message: string): Promise<HttpResponse<void>> {
        return new Promise<HttpResponse<void>>(resolve => {
            this.apiService.post(`${this.resourceUrl}/request-custom-quote`, {}, { message: message }).subscribe({
                next: () => {
                    this.messageService.add(
                        ToasterHelper.success(
                            this.translateService.instant(
                                'dashboard.templatesAndForm.requestQuoteForCustomWorkModal.success'
                            )
                        )
                    );
                    resolve({ data: null, status: HttpStatusEnum.SUCCESS });
                },
                error: async () => {
                    resolve({ data: null, status: HttpStatusEnum.ERROR });
                },
            });
        });
    }
}
